import styles from './HowItWorksSection.module.css';
import { MARK_OUTLINE } from '../../../../components/ContourBackdrop/ContourBackdrop';
import { useIntl } from 'react-intl';

const HowItWorksSection = () => {
	const intl = useIntl();
	const steps = [
		{
			title: intl.formatMessage({ id: 'HowItWorksId3' }),
			description: intl.formatMessage({ id: 'HowItWorksId4' }),
		},
		{
			title: intl.formatMessage({ id: 'HowItWorksId5' }),
			description: intl.formatMessage({ id: 'HowItWorksId6' }),
		},
		{
			title: intl.formatMessage({ id: 'HowItWorksId7' }),
			description: intl.formatMessage({ id: 'HowItWorksId8' }),
		},
	];
	return (
		<section className={styles.section} id='how-it-works'>
			<div className={styles.header}>
				<h2 className={styles.title}>
					{intl.formatMessage({ id: 'HowItWorksId2' })}
				</h2>
				<p className={styles.subtitle}>
					{intl.formatMessage({ id: 'HowItWorksId1' })}
				</p>
			</div>

			<div className={styles.grid}>
				{steps.map((step, index) => (
					<div key={index} className={styles.step}>
						{/* The FinPath mark, filled with the mockup's soft mint wash and
                carrying the step number. */}
						<div className={styles.badge}>
							<svg
								className={styles.badgeShape}
								viewBox='0 0 112 112'
								aria-hidden='true'
								focusable='false'
							>
								<defs>
									<radialGradient
										id={`stepBadge${index}`}
										cx='44%'
										cy='36%'
										r='72%'
									>
										<stop offset='0%' stopColor='#ffffff' />
										<stop offset='46%' stopColor='#eef8f2' />
										<stop offset='100%' stopColor='#7cc5a3' />
									</radialGradient>
								</defs>
								<path d={MARK_OUTLINE} fill={`url(#stepBadge${index})`} />
							</svg>
							<span className={styles.badgeNumber}>{index + 1}</span>
						</div>
						<div className={styles.stepContent}>
							<h3 className={styles.stepTitle}>{step.title}</h3>
							<p className={styles.stepDescription}>{step.description}</p>
						</div>
					</div>
				))}
			</div>
		</section>
	);
};

export default HowItWorksSection;
